unit Unit3;

interface

uses
  SysUtils, Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.StdCtrls, WEBLib.ExtCtrls;

type
  TForm3 = class(TForm)
    WebGroupBox4: TGroupBox;
    WebLabel66: TLabel;
    WebEdit36: TEdit;
    WebEdit40: TEdit;
    WebEdit41: TEdit;
    WebEdit43: TEdit;
    WebEdit1: TEdit;
    WebEdit2: TEdit;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebEdit17: TEdit;
    WebEdit18: TEdit;
    WebEdit23: TEdit;
    WebEdit24: TEdit;
    WebEdit28: TEdit;
    WebEdit29: TEdit;
    WebEdit30: TEdit;
    WebEdit31: TEdit;
    WebEdit34: TEdit;
    WebEdit35: TEdit;
    WebEdit47: TEdit;
    WebEdit48: TEdit;
    WebEdit49: TEdit;
    WebEdit54: TEdit;
    WebEdit55: TEdit;
    WebLabel7: TLabel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebEdit56: TEdit;
    WebEdit57: TEdit;
    WebEdit58: TEdit;
    WebEdit59: TEdit;
    WebEdit60: TEdit;
    WebEdit3: TEdit;
    WebEdit4: TEdit;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebLabel71: TLabel;
    WebLabel77: TLabel;
    WebLabel79: TLabel;
    WebLabel80: TLabel;
    WebLabel85: TLabel;
    WebLabel87: TLabel;
    WebLabel89: TLabel;
    WebLabel4: TLabel;
    WebLabel3: TLabel;
    WebLabel91: TLabel;
    WebLabel16: TLabel;
    WebLabel68: TLabel;
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form3: TForm3;

implementation


procedure TForm3.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel7 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebGroupBox4 := TGroupBox.Create(Self);
  WebLabel66 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel71 := TLabel.Create(Self);
  WebLabel77 := TLabel.Create(Self);
  WebLabel79 := TLabel.Create(Self);
  WebLabel80 := TLabel.Create(Self);
  WebLabel85 := TLabel.Create(Self);
  WebLabel87 := TLabel.Create(Self);
  WebLabel89 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel91 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel68 := TLabel.Create(Self);
  WebEdit36 := TEdit.Create(Self);
  WebEdit40 := TEdit.Create(Self);
  WebEdit41 := TEdit.Create(Self);
  WebEdit43 := TEdit.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit17 := TEdit.Create(Self);
  WebEdit18 := TEdit.Create(Self);
  WebEdit23 := TEdit.Create(Self);
  WebEdit24 := TEdit.Create(Self);
  WebEdit28 := TEdit.Create(Self);
  WebEdit29 := TEdit.Create(Self);
  WebEdit30 := TEdit.Create(Self);
  WebEdit31 := TEdit.Create(Self);
  WebEdit34 := TEdit.Create(Self);
  WebEdit35 := TEdit.Create(Self);
  WebEdit47 := TEdit.Create(Self);
  WebEdit48 := TEdit.Create(Self);
  WebEdit49 := TEdit.Create(Self);
  WebEdit54 := TEdit.Create(Self);
  WebEdit55 := TEdit.Create(Self);
  WebEdit56 := TEdit.Create(Self);
  WebEdit57 := TEdit.Create(Self);
  WebEdit58 := TEdit.Create(Self);
  WebEdit59 := TEdit.Create(Self);
  WebEdit60 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);

  WebLabel7.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebGroupBox4.BeforeLoadDFMValues;
  WebLabel66.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel71.BeforeLoadDFMValues;
  WebLabel77.BeforeLoadDFMValues;
  WebLabel79.BeforeLoadDFMValues;
  WebLabel80.BeforeLoadDFMValues;
  WebLabel85.BeforeLoadDFMValues;
  WebLabel87.BeforeLoadDFMValues;
  WebLabel89.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel91.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel68.BeforeLoadDFMValues;
  WebEdit36.BeforeLoadDFMValues;
  WebEdit40.BeforeLoadDFMValues;
  WebEdit41.BeforeLoadDFMValues;
  WebEdit43.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit17.BeforeLoadDFMValues;
  WebEdit18.BeforeLoadDFMValues;
  WebEdit23.BeforeLoadDFMValues;
  WebEdit24.BeforeLoadDFMValues;
  WebEdit28.BeforeLoadDFMValues;
  WebEdit29.BeforeLoadDFMValues;
  WebEdit30.BeforeLoadDFMValues;
  WebEdit31.BeforeLoadDFMValues;
  WebEdit34.BeforeLoadDFMValues;
  WebEdit35.BeforeLoadDFMValues;
  WebEdit47.BeforeLoadDFMValues;
  WebEdit48.BeforeLoadDFMValues;
  WebEdit49.BeforeLoadDFMValues;
  WebEdit54.BeforeLoadDFMValues;
  WebEdit55.BeforeLoadDFMValues;
  WebEdit56.BeforeLoadDFMValues;
  WebEdit57.BeforeLoadDFMValues;
  WebEdit58.BeforeLoadDFMValues;
  WebEdit59.BeforeLoadDFMValues;
  WebEdit60.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  try
    Name := 'Form3';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 429;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 403;
    WebLabel7.Width := 204;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator wycena firmy - Biz24.pl (c) 2020';
    WebLabel7.Color := clYellow;
    WebLabel7.Transparent := False;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 2;
    WebLabel1.Width := 159;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Kalkulacja wyceny firmy ';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clMenuHighlight;
    WebLabel1.Font.Height := 16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.ParentFont := False;
    WebGroupBox4.SetParentComponent(Self);
    WebGroupBox4.Name := 'WebGroupBox4';
    WebGroupBox4.Left := 8;
    WebGroupBox4.Top := 24;
    WebGroupBox4.Width := 620;
    WebGroupBox4.Height := 367;
    WebGroupBox4.Caption := 'Kalkulacja wyceny firmy ';
    WebGroupBox4.ChildOrder := 27;
    WebLabel66.SetParentComponent(WebGroupBox4);
    WebLabel66.Name := 'WebLabel66';
    WebLabel66.Left := 18;
    WebLabel66.Top := 22;
    WebLabel66.Width := 22;
    WebLabel66.Height := 13;
    WebLabel66.Caption := 'Rok';
    WebLabel66.Font.Charset := DEFAULT_CHARSET;
    WebLabel66.Font.Color := clWindowText;
    WebLabel66.Font.Height := -11;
    WebLabel66.Font.Name := 'Tahoma';
    WebLabel66.Font.Style := [fsBold];
    WebLabel66.ParentFont := False;
    WebLabel2.SetParentComponent(WebGroupBox4);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 18;
    WebLabel2.Top := 46;
    WebLabel2.Width := 64;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Kolejny rok';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -11;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.ParentFont := False;
    WebLabel5.SetParentComponent(WebGroupBox4);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 581;
    WebLabel5.Top := 98;
    WebLabel5.Width := 18;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'PLN';
    WebLabel6.SetParentComponent(WebGroupBox4);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 581;
    WebLabel6.Top := 148;
    WebLabel6.Width := 18;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'PLN';
    WebLabel8.SetParentComponent(WebGroupBox4);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 581;
    WebLabel8.Top := 173;
    WebLabel8.Width := 18;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'PLN';
    WebLabel9.SetParentComponent(WebGroupBox4);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 581;
    WebLabel9.Top := 198;
    WebLabel9.Width := 18;
    WebLabel9.Height := 13;
    WebLabel9.Caption := 'PLN';
    WebLabel10.SetParentComponent(WebGroupBox4);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 581;
    WebLabel10.Top := 223;
    WebLabel10.Width := 18;
    WebLabel10.Height := 13;
    WebLabel10.Caption := 'PLN';
    WebLabel11.SetParentComponent(WebGroupBox4);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 581;
    WebLabel11.Top := 248;
    WebLabel11.Width := 18;
    WebLabel11.Height := 13;
    WebLabel11.Caption := 'PLN';
    WebLabel12.SetParentComponent(WebGroupBox4);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 581;
    WebLabel12.Top := 273;
    WebLabel12.Width := 18;
    WebLabel12.Height := 13;
    WebLabel12.Caption := 'PLN';
    WebLabel13.SetParentComponent(WebGroupBox4);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 581;
    WebLabel13.Top := 296;
    WebLabel13.Width := 18;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'PLN';
    WebLabel14.SetParentComponent(WebGroupBox4);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 581;
    WebLabel14.Top := 319;
    WebLabel14.Width := 18;
    WebLabel14.Height := 13;
    WebLabel14.Caption := 'PLN';
    WebLabel15.SetParentComponent(WebGroupBox4);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 581;
    WebLabel15.Top := 342;
    WebLabel15.Width := 18;
    WebLabel15.Height := 13;
    WebLabel15.Caption := 'PLN';
    WebLabel71.SetParentComponent(WebGroupBox4);
    WebLabel71.Name := 'WebLabel71';
    WebLabel71.Left := 18;
    WebLabel71.Top := 98;
    WebLabel71.Width := 120;
    WebLabel71.Height := 13;
    WebLabel71.Caption := 'Cash Flow po 5 latach';
    WebLabel71.Font.Charset := DEFAULT_CHARSET;
    WebLabel71.Font.Color := clWindowText;
    WebLabel71.Font.Height := -11;
    WebLabel71.Font.Name := 'Tahoma';
    WebLabel71.Font.Style := [fsBold];
    WebLabel71.ParentFont := False;
    WebLabel77.SetParentComponent(WebGroupBox4);
    WebLabel77.Name := 'WebLabel77';
    WebLabel77.Left := 18;
    WebLabel77.Top := 148;
    WebLabel77.Width := 109;
    WebLabel77.Height := 13;
    WebLabel77.Caption := 'Warto'#347#263' resztkowa';
    WebLabel77.Font.Charset := DEFAULT_CHARSET;
    WebLabel77.Font.Color := clWindowText;
    WebLabel77.Font.Height := -11;
    WebLabel77.Font.Name := 'Tahoma';
    WebLabel77.Font.Style := [fsBold];
    WebLabel77.ParentFont := False;
    WebLabel79.SetParentComponent(WebGroupBox4);
    WebLabel79.Name := 'WebLabel79';
    WebLabel79.Left := 18;
    WebLabel79.Top := 173;
    WebLabel79.Width := 43;
    WebLabel79.Height := 13;
    WebLabel79.Caption := 'Odsetki';
    WebLabel79.Font.Charset := DEFAULT_CHARSET;
    WebLabel79.Font.Color := clWindowText;
    WebLabel79.Font.Height := -11;
    WebLabel79.Font.Name := 'Tahoma';
    WebLabel79.Font.Style := [fsBold];
    WebLabel79.ParentFont := False;
    WebLabel80.SetParentComponent(WebGroupBox4);
    WebLabel80.Name := 'WebLabel80';
    WebLabel80.Left := 18;
    WebLabel80.Top := 198;
    WebLabel80.Width := 171;
    WebLabel80.Height := 13;
    WebLabel80.Caption := 'Wynik przed opodatkowaniem';
    WebLabel80.Font.Charset := DEFAULT_CHARSET;
    WebLabel80.Font.Color := clWindowText;
    WebLabel80.Font.Height := -11;
    WebLabel80.Font.Name := 'Tahoma';
    WebLabel80.Font.Style := [fsBold];
    WebLabel80.ParentFont := False;
    WebLabel85.SetParentComponent(WebGroupBox4);
    WebLabel85.Name := 'WebLabel85';
    WebLabel85.Left := 18;
    WebLabel85.Top := 223;
    WebLabel85.Width := 196;
    WebLabel85.Height := 13;
    WebLabel85.Caption := 'Suma zweryfikownanego CashFlow';
    WebLabel85.Font.Charset := DEFAULT_CHARSET;
    WebLabel85.Font.Color := clWindowText;
    WebLabel85.Font.Height := -11;
    WebLabel85.Font.Name := 'Tahoma';
    WebLabel85.Font.Style := [fsBold];
    WebLabel85.ParentFont := False;
    WebLabel87.SetParentComponent(WebGroupBox4);
    WebLabel87.Name := 'WebLabel87';
    WebLabel87.Left := 17;
    WebLabel87.Top := 248;
    WebLabel87.Width := 56;
    WebLabel87.Height := 13;
    WebLabel87.Caption := 'Iwestycje';
    WebLabel87.Font.Charset := DEFAULT_CHARSET;
    WebLabel87.Font.Color := clWindowText;
    WebLabel87.Font.Height := -11;
    WebLabel87.Font.Name := 'Tahoma';
    WebLabel87.Font.Style := [fsBold];
    WebLabel87.ParentFont := False;
    WebLabel89.SetParentComponent(WebGroupBox4);
    WebLabel89.Name := 'WebLabel89';
    WebLabel89.Left := 17;
    WebLabel89.Top := 273;
    WebLabel89.Width := 80;
    WebLabel89.Height := 13;
    WebLabel89.Caption := 'Warto'#347#263' firmy';
    WebLabel89.Font.Charset := DEFAULT_CHARSET;
    WebLabel89.Font.Color := clWindowText;
    WebLabel89.Font.Height := -11;
    WebLabel89.Font.Name := 'Tahoma';
    WebLabel89.Font.Style := [fsBold];
    WebLabel89.ParentFont := False;
    WebLabel4.SetParentComponent(WebGroupBox4);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 18;
    WebLabel4.Top := 342;
    WebLabel4.Width := 80;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Warto'#347#263' firmy';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clBlack;
    WebLabel4.Font.Height := -11;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.ParentFont := False;
    WebLabel3.SetParentComponent(WebGroupBox4);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 18;
    WebLabel3.Top := 319;
    WebLabel3.Width := 162;
    WebLabel3.Height := 13;
    WebLabel3.Caption := #346'rodki zb'#281'dne w dzia'#322'alno'#347'ci firmy';
    WebLabel91.SetParentComponent(WebGroupBox4);
    WebLabel91.Name := 'WebLabel91';
    WebLabel91.Left := 17;
    WebLabel91.Top := 296;
    WebLabel91.Width := 60;
    WebLabel91.Height := 13;
    WebLabel91.Caption := 'Obcy kapita'#322;
    WebLabel16.SetParentComponent(WebGroupBox4);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 18;
    WebLabel16.Top := 123;
    WebLabel16.Width := 126;
    WebLabel16.Height := 13;
    WebLabel16.Caption := 'Wspo'#322'czynnik gotowki';
    WebLabel16.Font.Charset := DEFAULT_CHARSET;
    WebLabel16.Font.Color := clWindowText;
    WebLabel16.Font.Height := -11;
    WebLabel16.Font.Name := 'Tahoma';
    WebLabel16.Font.Style := [fsBold];
    WebLabel16.ParentFont := False;
    WebLabel68.SetParentComponent(WebGroupBox4);
    WebLabel68.Name := 'WebLabel68';
    WebLabel68.Left := 18;
    WebLabel68.Top := 73;
    WebLabel68.Width := 181;
    WebLabel68.Height := 13;
    WebLabel68.Caption := 'Wspolcznniki obni'#380'enia warto'#347'ci';
    WebLabel68.Font.Charset := DEFAULT_CHARSET;
    WebLabel68.Font.Color := clWindowText;
    WebLabel68.Font.Height := -11;
    WebLabel68.Font.Name := 'Tahoma';
    WebLabel68.Font.Style := [fsBold];
    WebLabel68.ParentFont := False;
    WebEdit36.SetParentComponent(WebGroupBox4);
    WebEdit36.Name := 'WebEdit36';
    WebEdit36.Left := 234;
    WebEdit36.Top := 70;
    WebEdit36.Width := 61;
    WebEdit36.Height := 19;
    WebEdit36.ChildOrder := 1;
    WebEdit36.Color := 12903679;
    WebEdit36.Enabled := False;
    WebEdit36.Text := '1,00';
    WebEdit40.SetParentComponent(WebGroupBox4);
    WebEdit40.Name := 'WebEdit40';
    WebEdit40.Left := 234;
    WebEdit40.Top := 170;
    WebEdit40.Width := 61;
    WebEdit40.Height := 19;
    WebEdit40.ChildOrder := 5;
    WebEdit40.Color := 12903679;
    WebEdit40.Enabled := False;
    WebEdit40.Text := '430000';
    WebEdit41.SetParentComponent(WebGroupBox4);
    WebEdit41.Name := 'WebEdit41';
    WebEdit41.Left := 234;
    WebEdit41.Top := 195;
    WebEdit41.Width := 61;
    WebEdit41.Height := 19;
    WebEdit41.ChildOrder := 6;
    WebEdit41.Color := 12903679;
    WebEdit41.Text := '430000';
    WebEdit43.SetParentComponent(WebGroupBox4);
    WebEdit43.Name := 'WebEdit43';
    WebEdit43.Left := 234;
    WebEdit43.Top := 19;
    WebEdit43.Width := 61;
    WebEdit43.Height := 19;
    WebEdit43.ChildOrder := 8;
    WebEdit43.Color := 12903679;
    WebEdit43.Enabled := False;
    WebEdit43.Text := '2020';
    WebEdit1.SetParentComponent(WebGroupBox4);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 304;
    WebEdit1.Top := 19;
    WebEdit1.Width := 61;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 8;
    WebEdit1.Color := 12903679;
    WebEdit1.Enabled := False;
    WebEdit1.Text := '2021';
    WebEdit2.SetParentComponent(WebGroupBox4);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 304;
    WebEdit2.Top := 70;
    WebEdit2.Width := 61;
    WebEdit2.Height := 19;
    WebEdit2.ChildOrder := 1;
    WebEdit2.Color := 12903679;
    WebEdit2.Enabled := False;
    WebEdit2.Text := '0,9116';
    WebEdit6.SetParentComponent(WebGroupBox4);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 304;
    WebEdit6.Top := 170;
    WebEdit6.Width := 61;
    WebEdit6.Height := 19;
    WebEdit6.ChildOrder := 5;
    WebEdit6.Color := 12903679;
    WebEdit6.Enabled := False;
    WebEdit6.Text := '370000';
    WebEdit7.SetParentComponent(WebGroupBox4);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 304;
    WebEdit7.Top := 195;
    WebEdit7.Width := 61;
    WebEdit7.Height := 19;
    WebEdit7.ChildOrder := 6;
    WebEdit7.Color := 12903679;
    WebEdit7.Enabled := False;
    WebEdit7.Text := '327000';
    WebEdit12.SetParentComponent(WebGroupBox4);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 374;
    WebEdit12.Top := 19;
    WebEdit12.Width := 61;
    WebEdit12.Height := 19;
    WebEdit12.ChildOrder := 8;
    WebEdit12.Color := 12903679;
    WebEdit12.Enabled := False;
    WebEdit12.Text := '2022';
    WebEdit13.SetParentComponent(WebGroupBox4);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 374;
    WebEdit13.Top := 70;
    WebEdit13.Width := 61;
    WebEdit13.Height := 19;
    WebEdit13.ChildOrder := 1;
    WebEdit13.Color := 12903679;
    WebEdit13.Enabled := False;
    WebEdit13.Text := '0,8310';
    WebEdit17.SetParentComponent(WebGroupBox4);
    WebEdit17.Name := 'WebEdit17';
    WebEdit17.Left := 374;
    WebEdit17.Top := 170;
    WebEdit17.Width := 61;
    WebEdit17.Height := 19;
    WebEdit17.ChildOrder := 5;
    WebEdit17.Color := 12903679;
    WebEdit17.Enabled := False;
    WebEdit17.Text := '410000';
    WebEdit18.SetParentComponent(WebGroupBox4);
    WebEdit18.Name := 'WebEdit18';
    WebEdit18.Left := 374;
    WebEdit18.Top := 195;
    WebEdit18.Width := 61;
    WebEdit18.Height := 19;
    WebEdit18.ChildOrder := 6;
    WebEdit18.Color := 12903679;
    WebEdit18.Enabled := False;
    WebEdit18.Text := '341000';
    WebEdit23.SetParentComponent(WebGroupBox4);
    WebEdit23.Name := 'WebEdit23';
    WebEdit23.Left := 444;
    WebEdit23.Top := 19;
    WebEdit23.Width := 61;
    WebEdit23.Height := 19;
    WebEdit23.ChildOrder := 8;
    WebEdit23.Color := 12903679;
    WebEdit23.Enabled := False;
    WebEdit23.Text := '2023';
    WebEdit24.SetParentComponent(WebGroupBox4);
    WebEdit24.Name := 'WebEdit24';
    WebEdit24.Left := 444;
    WebEdit24.Top := 70;
    WebEdit24.Width := 61;
    WebEdit24.Height := 19;
    WebEdit24.ChildOrder := 1;
    WebEdit24.Color := 12903679;
    WebEdit24.Enabled := False;
    WebEdit24.Text := '0,7575';
    WebEdit28.SetParentComponent(WebGroupBox4);
    WebEdit28.Name := 'WebEdit28';
    WebEdit28.Left := 444;
    WebEdit28.Top := 170;
    WebEdit28.Width := 61;
    WebEdit28.Height := 19;
    WebEdit28.ChildOrder := 5;
    WebEdit28.Color := 12903679;
    WebEdit28.Enabled := False;
    WebEdit28.Text := '370000';
    WebEdit29.SetParentComponent(WebGroupBox4);
    WebEdit29.Name := 'WebEdit29';
    WebEdit29.Left := 444;
    WebEdit29.Top := 195;
    WebEdit29.Width := 61;
    WebEdit29.Height := 19;
    WebEdit29.ChildOrder := 6;
    WebEdit29.Color := 12903679;
    WebEdit29.Enabled := False;
    WebEdit29.Text := '280000';
    WebEdit30.SetParentComponent(WebGroupBox4);
    WebEdit30.Name := 'WebEdit30';
    WebEdit30.Left := 444;
    WebEdit30.Top := 220;
    WebEdit30.Width := 61;
    WebEdit30.Height := 19;
    WebEdit30.ChildOrder := 7;
    WebEdit30.Color := 12903679;
    WebEdit30.Enabled := False;
    WebEdit30.Text := '1388000';
    WebEdit31.SetParentComponent(WebGroupBox4);
    WebEdit31.Name := 'WebEdit31';
    WebEdit31.Left := 514;
    WebEdit31.Top := 245;
    WebEdit31.Width := 61;
    WebEdit31.Height := 19;
    WebEdit31.ChildOrder := 7;
    WebEdit31.Color := 12903679;
    WebEdit31.Enabled := False;
    WebEdit31.Text := '2634000';
    WebEdit34.SetParentComponent(WebGroupBox4);
    WebEdit34.Name := 'WebEdit34';
    WebEdit34.Left := 514;
    WebEdit34.Top := 19;
    WebEdit34.Width := 61;
    WebEdit34.Height := 19;
    WebEdit34.ChildOrder := 8;
    WebEdit34.Color := 12903679;
    WebEdit34.Enabled := False;
    WebEdit34.Text := '2024';
    WebEdit35.SetParentComponent(WebGroupBox4);
    WebEdit35.Name := 'WebEdit35';
    WebEdit35.Left := 514;
    WebEdit35.Top := 70;
    WebEdit35.Width := 61;
    WebEdit35.Height := 19;
    WebEdit35.ChildOrder := 1;
    WebEdit35.Color := 12903679;
    WebEdit35.Enabled := False;
    WebEdit35.Text := '0,6905';
    WebEdit47.SetParentComponent(WebGroupBox4);
    WebEdit47.Name := 'WebEdit47';
    WebEdit47.Left := 514;
    WebEdit47.Top := 95;
    WebEdit47.Width := 61;
    WebEdit47.Height := 19;
    WebEdit47.ChildOrder := 2;
    WebEdit47.Color := 12903679;
    WebEdit47.Enabled := False;
    WebEdit47.Text := '370000';
    WebEdit48.SetParentComponent(WebGroupBox4);
    WebEdit48.Name := 'WebEdit48';
    WebEdit48.Left := 514;
    WebEdit48.Top := 120;
    WebEdit48.Width := 61;
    WebEdit48.Height := 19;
    WebEdit48.ChildOrder := 3;
    WebEdit48.Color := 12903679;
    WebEdit48.Enabled := False;
    WebEdit48.Text := '10,3093';
    WebEdit49.SetParentComponent(WebGroupBox4);
    WebEdit49.Name := 'WebEdit49';
    WebEdit49.Left := 514;
    WebEdit49.Top := 145;
    WebEdit49.Width := 61;
    WebEdit49.Height := 19;
    WebEdit49.ChildOrder := 4;
    WebEdit49.Color := 12903679;
    WebEdit49.Enabled := False;
    WebEdit49.Text := '3814000';
    WebEdit54.SetParentComponent(WebGroupBox4);
    WebEdit54.Name := 'WebEdit54';
    WebEdit54.Left := 513;
    WebEdit54.Top := 270;
    WebEdit54.Width := 61;
    WebEdit54.Height := 19;
    WebEdit54.ChildOrder := 7;
    WebEdit54.Color := 12903679;
    WebEdit54.Enabled := False;
    WebEdit54.Text := '4022000';
    WebEdit55.SetParentComponent(WebGroupBox4);
    WebEdit55.Name := 'WebEdit55';
    WebEdit55.Left := 513;
    WebEdit55.Top := 293;
    WebEdit55.Width := 61;
    WebEdit55.Height := 19;
    WebEdit55.ChildOrder := 7;
    WebEdit55.Color := clInfoBk;
    WebEdit55.Text := '2022000';
    WebEdit56.SetParentComponent(WebGroupBox4);
    WebEdit56.Name := 'WebEdit56';
    WebEdit56.Left := 234;
    WebEdit56.Top := 43;
    WebEdit56.Width := 61;
    WebEdit56.Height := 19;
    WebEdit56.ChildOrder := 8;
    WebEdit56.Color := 12903679;
    WebEdit56.Enabled := False;
    WebEdit56.Text := '1';
    WebEdit57.SetParentComponent(WebGroupBox4);
    WebEdit57.Name := 'WebEdit57';
    WebEdit57.Left := 304;
    WebEdit57.Top := 43;
    WebEdit57.Width := 61;
    WebEdit57.Height := 19;
    WebEdit57.ChildOrder := 8;
    WebEdit57.Color := 12903679;
    WebEdit57.Enabled := False;
    WebEdit57.Text := '2';
    WebEdit58.SetParentComponent(WebGroupBox4);
    WebEdit58.Name := 'WebEdit58';
    WebEdit58.Left := 374;
    WebEdit58.Top := 43;
    WebEdit58.Width := 61;
    WebEdit58.Height := 19;
    WebEdit58.ChildOrder := 8;
    WebEdit58.Color := 12903679;
    WebEdit58.Enabled := False;
    WebEdit58.Text := '3';
    WebEdit59.SetParentComponent(WebGroupBox4);
    WebEdit59.Name := 'WebEdit59';
    WebEdit59.Left := 444;
    WebEdit59.Top := 43;
    WebEdit59.Width := 61;
    WebEdit59.Height := 19;
    WebEdit59.ChildOrder := 8;
    WebEdit59.Color := 12903679;
    WebEdit59.Enabled := False;
    WebEdit59.Text := '4';
    WebEdit60.SetParentComponent(WebGroupBox4);
    WebEdit60.Name := 'WebEdit60';
    WebEdit60.Left := 514;
    WebEdit60.Top := 43;
    WebEdit60.Width := 61;
    WebEdit60.Height := 19;
    WebEdit60.ChildOrder := 8;
    WebEdit60.Color := 12903679;
    WebEdit60.Enabled := False;
    WebEdit60.Text := '5';
    WebEdit3.SetParentComponent(WebGroupBox4);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 514;
    WebEdit3.Top := 316;
    WebEdit3.Width := 61;
    WebEdit3.Height := 19;
    WebEdit3.ChildOrder := 7;
    WebEdit3.Color := clInfoBk;
    WebEdit3.Text := '0';
    WebEdit4.SetParentComponent(WebGroupBox4);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 514;
    WebEdit4.Top := 339;
    WebEdit4.Width := 61;
    WebEdit4.Height := 19;
    WebEdit4.ChildOrder := 7;
    WebEdit4.Color := 12903679;
    WebEdit4.Enabled := False;
    WebEdit4.Text := '2000000';
  finally
    WebLabel7.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebGroupBox4.AfterLoadDFMValues;
    WebLabel66.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel71.AfterLoadDFMValues;
    WebLabel77.AfterLoadDFMValues;
    WebLabel79.AfterLoadDFMValues;
    WebLabel80.AfterLoadDFMValues;
    WebLabel85.AfterLoadDFMValues;
    WebLabel87.AfterLoadDFMValues;
    WebLabel89.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel91.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel68.AfterLoadDFMValues;
    WebEdit36.AfterLoadDFMValues;
    WebEdit40.AfterLoadDFMValues;
    WebEdit41.AfterLoadDFMValues;
    WebEdit43.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit17.AfterLoadDFMValues;
    WebEdit18.AfterLoadDFMValues;
    WebEdit23.AfterLoadDFMValues;
    WebEdit24.AfterLoadDFMValues;
    WebEdit28.AfterLoadDFMValues;
    WebEdit29.AfterLoadDFMValues;
    WebEdit30.AfterLoadDFMValues;
    WebEdit31.AfterLoadDFMValues;
    WebEdit34.AfterLoadDFMValues;
    WebEdit35.AfterLoadDFMValues;
    WebEdit47.AfterLoadDFMValues;
    WebEdit48.AfterLoadDFMValues;
    WebEdit49.AfterLoadDFMValues;
    WebEdit54.AfterLoadDFMValues;
    WebEdit55.AfterLoadDFMValues;
    WebEdit56.AfterLoadDFMValues;
    WebEdit57.AfterLoadDFMValues;
    WebEdit58.AfterLoadDFMValues;
    WebEdit59.AfterLoadDFMValues;
    WebEdit60.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
  end;
end;

end.